import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { FormattedMessagePropType } from '../../../prop-types/intl';
import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';

import style from './cancel-prompt-modal.module.less';
import { noop } from 'ui-components/default-props/noop';

const defaultActions = {
  cancelShipment: noop,
};

export const CancelPromptModal = ({ modalFrameworkMethods, title, message, confirmation, actions = defaultActions }) => {
  const { closeModal } = modalFrameworkMethods;
  return (
    <Modal className={style['cancel-modal']}>
      <ModalHeader closeModal={closeModal}>{title}</ModalHeader>
      <ModalBody className={style['modal-body']}>
        <div className={style['modal-body-text']}>
          {message}
          <br />
          <br />
          {confirmation}
        </div>
      </ModalBody>
      <ModalFooter className={style['modal-footer']}>
        <Button onClick={closeModal} theme='tertiary'>
          <FormattedMessage defaultMessage='Cancel' description='cancelShipmentPromptModal.cancel' id='srvEoN' />
        </Button>
        <Button
          onClick={() => {
            actions.cancel();
          }}
          theme='primary'
        >
          {title}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

CancelPromptModal.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
  title: FormattedMessagePropType.isRequired,
  message: FormattedMessagePropType.isRequired,
  confirmation: FormattedMessagePropType.isRequired,
  actions: PropTypes.object,
};
